module.exports = __webpack_public_path__ + "static/v_3-7c1c6aca3274dc44f45d8440297af903.mp4";